import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vant from 'vant';
import 'vant/lib/index.css';
import 'lib-flexible'

// eleUI
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI)

import Router from 'vue-router'
const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return routerPush.call(this, location).catch(error => error)
}

//swiper
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
Vue.use(VueAwesomeSwiper, /* { default options with global component } */ )
    // 图片懒加载
import { Lazyload } from "vant";

Vue.use(Lazyload);
//页面title
import MetaInfo from 'vue-meta-info'
Vue.use(MetaInfo)

// 导入bootstrap
import "bootstrap"
import "bootstrap/dist/css/bootstrap.css"

import './assets/css/reset.css'
Vue.config.productionTip = false

Vue.use(Vant);

// axios
import axios from 'axios';
Vue.prototype.$axios = axios;

// 每次路由跳转返回顶部
router.afterEach(() => {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    })
    // 滚动插件
import scroll from 'vue-seamless-scroll'
Vue.use(scroll)
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')

// 阿里图标库
import "@/P08_HanTeng/assets/fonts/iconfont.css"